import { ServiceFetch } from '../service-fetch'

export default class StockMoveMainListZoneModel extends ServiceFetch {
    getStockMoveMainListZoneBy = (data) => this.authFetch({
        url: 'stock-move-main-list-zone/getStockMoveMainListZoneBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
}
